import { ItemType } from "../../defines/enums"
import { Player } from "../../player/player"

export class Gizmo {
  private _timeoutID: number | undefined = undefined

  private _active: boolean = false
  private _onCooldown: boolean = false

  private _type: ItemType
  private _cooldownTimer: number
  private _usageTimer: number
  private _player: Player

  private _callback?: (player: Player) => void = undefined

  constructor(
    type: ItemType,
    usageTimer: number,
    cooldownTimer: number,
    player: Player
  ) {
    this._type = type
    this._usageTimer = usageTimer
    this._cooldownTimer = cooldownTimer
    this._player = player
  }

  set callback(c: (player: Player) => void) {
    this._callback = c
  }

  get active(): boolean {
    return this._active
  }

  get onCooldown(): boolean {
    return this._onCooldown
  }

  get type(): ItemType {
    return this._type
  }

  stop(): void {
    if (this._timeoutID !== undefined) {
      this._active = false
      this._onCooldown = false
      window.clearTimeout(this._timeoutID)
      this._timeoutID = undefined
    }
  }

  activate(): void {
    this._active = true
    this._timeoutID = window.setTimeout(() => {
      this._active = false
      this._onCooldown = true
      if (this._callback !== undefined) {
        this._callback(this._player)
      }
      this.cooldown()
    }, this._usageTimer)
  }

  private cooldown(): void {
    this._timeoutID = window.setInterval(() => {
      this._onCooldown = false
      if (this._callback !== undefined) {
        this._callback(this._player)
      }
    }, this._cooldownTimer)
  }
}
